<app-dialog-wrapper
  [title]="'results.detailedSkinAnalysis.title' | translate"
  [severity]="severity"
>
  <div>
    <div class="charset-list modal-wrapper">
      <div class="modal-charset-list"></div>
      <p class="m-t-10">
        {{ "results.detailedSkinAnalysis.description" | translate }}
      </p>

      @for (item of skinData; track item; let idx = $index) {
      <!-- acne -->
      @if (item.category == "results.biomarkers.skinCategories.acne") {
      <div class="modal-charset">
        <h5>{{ item.category | translate }}</h5>
        <p *ngIf="item.detected_types?.length > 0; else noacne">
          {{ "results.detailedSkinAnalysis.detectedTypes" | translate }}
        </p>
        <ng-template #noacne>
          <p>{{ "results.detailedSkinAnalysis.noAcneDetected" | translate }}</p>
        </ng-template>
        @for (detectedType of item.detected_types; track type; ) {
        <ul class="charset-list-container">
          <li>
            <p>
              <span class="bright-pink">{{
                detectedType.type | translate
              }}</span>
            </p>
          </li>
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.detectedMarks" | translate }}
              <span class="bright-pink">{{ detectedType.detected_marks }}</span>
            </p>
          </li>
          <li>
            <p class="m-t-10">{{ detectedType.content | translate }}</p>
          </li>
        </ul>
        }
      </div>
      } @if (item.category ==
      "results.biomarkers.skinCategories.skinSensitivity") {
      <div class="modal-charset">
        <h5>{{ item.category | translate }}</h5>
        <ul class="charset-list-container">
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.sensitivityLevel" | translate }}
              <span class="bright-pink">{{ item.sensitivity_level }}</span>
            </p>
          </li>
          <li>
            <p>
              {{
                "results.detailedSkinAnalysis.percentageOfSensitiveAreas"
                  | translate
              }}
              <span class="bright-pink">{{
                item.sensitivity_percentage + "%"
              }}</span>
            </p>
          </li>
          <li>
            <p class="m-t-10">{{ item.content | translate }}</p>
          </li>
        </ul>
      </div>
      }
      <!-- melasma -->
      @if (item.category == "results.biomarkers.skinCategories.melasma") {
      <div class="modal-charset">
        <h5>{{ item.category | translate }}</h5>
        <ul class="charset-list-container">
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.detectedMarks" | translate }}
              <span class="bright-pink">{{ item.detected_marks }}</span>
            </p>
          </li>
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.sensitivityLevel" | translate }}
              <span class="bright-pink">{{ item.severity | translate }}</span>
            </p>
          </li>
          <li>
            <p class="m-t-10">{{ item.content | translate }}</p>
          </li>
        </ul>
      </div>
      }
      <!-- dry/oily skin -->
      @if (item.category == "results.biomarkers.skinCategories.dryOilySkin") {
      <div class="modal-charset">
        <h5>{{ item.category | translate }}</h5>
        <ul class="charset-list-container">
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.skinType" | translate }}
              <span class="bright-pink">{{ item.skin_type | translate }}</span>
            </p>
          </li>
          <li>
            <p>
              {{
                "results.detailedSkinAnalysis.detectedBlackHeadsLevel"
                  | translate
              }}
              <span class="bright-pink">{{ item.detected_blackheads }}</span>
            </p>
          </li>
          <li>
            <p class="m-t-10">{{ item.content | translate }}</p>
          </li>
          <li>
            <p>{{ item.additional_info[0].type | translate }} :</p>
            <ol>
              <li>
                {{ "results.detailedSkinAnalysis.faceAreas.tZone" | translate }}
                <span class="bright-pink">{{
                  translateCombinedValue(item.additional_info[0].t_zone)
                }}</span>
              </li>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.leftCheek" | translate
                }}
                <span class="bright-pink">{{
                  translateCombinedValue(item.additional_info[0].left_cheek)
                }}</span>
              </li>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.rightCheek"
                    | translate
                }}
                <span class="bright-pink">{{
                  translateCombinedValue(item.additional_info[0].right_cheek)
                }}</span>
              </li>
              <li>
                {{ "results.detailedSkinAnalysis.faceAreas.chin" | translate }}
                <span class="bright-pink">{{
                  translateCombinedValue(item.additional_info[0].chin)
                }}</span>
              </li>
            </ol>
          </li>
          <li>
            <p>{{ item.additional_info[1].type | translate }} :</p>
            <ol>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.forehead" | translate
                }}
                <span class="bright-pink">{{
                  item.additional_info[1].forehead
                }}</span>
              </li>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.leftCheek" | translate
                }}
                <span class="bright-pink">{{
                  item.additional_info[1].left_cheek
                }}</span>
              </li>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.rightCheek"
                    | translate
                }}
                <span class="bright-pink">{{
                  item.additional_info[1].right_cheek
                }}</span>
              </li>
            </ol>
          </li>
          <li>
            <p>{{ item.additional_info[2].type | translate }} :</p>
            <ol>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.forehead" | translate
                }}
                <span class="bright-pink">{{
                  item.additional_info[2].forehead
                }}</span>
              </li>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.leftCheek" | translate
                }}
                <span class="bright-pink">{{
                  item.additional_info[2].left_cheek
                }}</span>
              </li>
              <li>
                {{
                  "results.detailedSkinAnalysis.faceAreas.rightCheek"
                    | translate
                }}
                <span class="bright-pink">{{
                  item.additional_info[2].right_cheek
                }}</span>
              </li>
              <li>
                {{ "results.detailedSkinAnalysis.faceAreas.chin" | translate }}
                <span class="bright-pink">{{
                  item.additional_info[2].chin
                }}</span>
              </li>
            </ol>
          </li>
        </ul>
      </div>
      }
      <!-- pigmentation-->
      @if (item.category == "results.biomarkers.skinCategories.pigmentation") {
      <div class="modal-charset">
        <h5>{{ item.category | translate }}</h5>
        <ul class="charset-list-container">
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.skinHueType" | translate }}
              <span class="bright-pink">{{
                item.skin_hue_type | translate
              }}</span>
            </p>
          </li>
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.melaninScore" | translate }}
              <span class="bright-pink">{{
                getMilanianScore(item.melanin_score)
              }}</span>
            </p>
          </li>
          <li>
            <p class="m-t-10">{{ item.content | translate }}</p>
          </li>
        </ul>
      </div>
      }
      <!-- wrinkles -->
      @if (item.category == "results.biomarkers.skinCategories.wrinkles") {
      <div class="modal-charset">
        <h5>{{ item.category | translate }}</h5>
        <ul class="charset-list-container">
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.detectedWrinkles" | translate }}
              <span class="bright-pink">{{ item.detected_wrinkles }}</span>
            </p>
          </li>
          <li>
            <p>
              {{
                "results.detailedSkinAnalysis.totalSeverityScore" | translate
              }}
              <span class="bright-pink">{{ item.total_severity_score }}</span>
            </p>
          </li>
          <li>
            <p>
              {{ "results.detailedSkinAnalysis.skinAge" | translate }}
              <span class="bright-pink">{{ item.skin_age }}</span>
            </p>
          </li>
          <li>
            <p class="m-t-10">{{ item.content | translate }}</p>
          </li>
          <li>
            {{ "results.detailedSkinAnalysis.detectedTypes" | translate }}
          </li>
          <ol class="bullet-list">
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.foreheadWrinkles"
                  | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].forehead_wrinkles | translate
              }}</span>
            </li>
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.smileLines"
                  | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].smile_lines | translate
              }}</span>
            </li>
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.eyeCrinkles"
                  | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].eye_crinckles | translate
              }}</span>
            </li>
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.frownys" | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].frownys | translate
              }}</span>
            </li>
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.foreheadFineLines"
                  | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].forehead_fine_lines | translate
              }}</span>
            </li>
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.foreheadDeepWrinkles"
                  | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].forehead_deep_wrinkles | translate
              }}</span>
            </li>
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.cheekFold"
                  | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].cheek_fold | translate
              }}</span>
            </li>
            <li>
              {{
                "results.detailedSkinAnalysis.wrinkleTypes.mouthWrinkles"
                  | translate
              }}
              <span class="bright-pink">{{
                item.detected_types[0].mouth_wrinkles | translate
              }}</span>
            </li>
          </ol>
        </ul>
      </div>
      } }
    </div>
  </div>
</app-dialog-wrapper>
